export default __webpack_public_path__ + "static/media/fleischers.09cfc462.jpg";